/**
 * @generated SignedSource<<020826b2d97213ec125edeb03abfc3f5>>
 * @relayHash e78f45ef84b0309b46cad2982bdd129a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d9dbad7f6be18f479464c7740ecc608e88f02669cea51d9e028e75b6b84f4eb9

import type { ConcreteRequest } from 'relay-runtime';
export type ContentStateRestrictionLevel = "NONE" | "PAGE_OWNER" | "%future added value";
export type GraphQLDateFormat = "GLOBAL" | "MILLIS" | "USER" | "USER_FRIENDLY" | "%future added value";
export type EditorContentStateQuery$variables = {
  contentId: string;
  format: GraphQLDateFormat;
  isApprovalsFgOn: boolean;
  isDraft: boolean;
  shouldSkipAvailableContentStates?: boolean | null | undefined;
  shouldSkipContentStateLastUpdated: boolean;
  shouldSkipEditOnlyFields?: boolean | null | undefined;
};
export type EditorContentStateQuery$data = {
  readonly availableContentStates?: {
    readonly customContentStates: ReadonlyArray<{
      readonly color: string;
      readonly id: string | null | undefined;
      readonly name: string;
    } | null | undefined> | null | undefined;
    readonly spaceContentStates: ReadonlyArray<{
      readonly color: string;
      readonly id: string | null | undefined;
      readonly name: string;
      readonly restrictionLevel: ContentStateRestrictionLevel;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly singleContent: {
    readonly contentState: {
      readonly color: string;
      readonly id: string | null | undefined;
      readonly isCallerPermitted?: boolean | null | undefined;
      readonly lastModifierAaid?: string | null | undefined;
      readonly name: string;
      readonly restrictionLevel: ContentStateRestrictionLevel;
    } | null | undefined;
    readonly contentStateLastUpdated?: {
      readonly value: string;
    } | null | undefined;
    readonly id: string | null | undefined;
  } | null | undefined;
};
export type EditorContentStateQuery = {
  response: EditorContentStateQuery$data;
  variables: EditorContentStateQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "format"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isApprovalsFgOn"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isDraft"
},
v4 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "shouldSkipAvailableContentStates"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldSkipContentStateLastUpdated"
},
v6 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "shouldSkipEditOnlyFields"
},
v7 = {
  "kind": "ScalarField",
  "name": "id"
},
v8 = {
  "kind": "Variable",
  "name": "isDraft",
  "variableName": "isDraft"
},
v9 = {
  "kind": "ScalarField",
  "name": "name"
},
v10 = {
  "kind": "ScalarField",
  "name": "color"
},
v11 = {
  "kind": "ScalarField",
  "name": "restrictionLevel"
},
v12 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      }
    ],
    "concreteType": "Content",
    "kind": "LinkedField",
    "name": "singleContent",
    "plural": false,
    "selections": [
      (v7/*: any*/),
      {
        "args": [
          (v8/*: any*/)
        ],
        "concreteType": "ContentState",
        "kind": "LinkedField",
        "name": "contentState",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          {
            "condition": "shouldSkipEditOnlyFields",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "isCallerPermitted"
              }
            ]
          },
          {
            "condition": "isApprovalsFgOn",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "lastModifierAaid"
              }
            ]
          }
        ]
      },
      {
        "condition": "shouldSkipContentStateLastUpdated",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "format",
                "variableName": "format"
              },
              (v8/*: any*/)
            ],
            "concreteType": "ConfluenceDate",
            "kind": "LinkedField",
            "name": "contentStateLastUpdated",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "value"
              }
            ]
          }
        ]
      }
    ]
  },
  {
    "condition": "shouldSkipAvailableContentStates",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "contentId",
            "variableName": "contentId"
          }
        ],
        "concreteType": "AvailableContentStates",
        "kind": "LinkedField",
        "name": "availableContentStates",
        "plural": false,
        "selections": [
          {
            "concreteType": "ContentState",
            "kind": "LinkedField",
            "name": "customContentStates",
            "plural": true,
            "selections": [
              (v9/*: any*/),
              (v10/*: any*/),
              (v7/*: any*/)
            ]
          },
          {
            "concreteType": "ContentState",
            "kind": "LinkedField",
            "name": "spaceContentStates",
            "plural": true,
            "selections": [
              (v9/*: any*/),
              (v10/*: any*/),
              (v7/*: any*/),
              (v11/*: any*/)
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "name": "EditorContentStateQuery",
    "selections": (v12/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v5/*: any*/),
      (v4/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Operation",
    "name": "EditorContentStateQuery",
    "selections": (v12/*: any*/)
  },
  "params": {
    "cacheID": "e78f45ef84b0309b46cad2982bdd129a",
    "id": "d9dbad7f6be18f479464c7740ecc608e88f02669cea51d9e028e75b6b84f4eb9",
    "metadata": {},
    "name": "EditorContentStateQuery",
    "operationKind": "query",
    "text": "query EditorContentStateQuery($contentId:ID!,$isDraft:Boolean!,$isApprovalsFgOn:Boolean!,$format:GraphQLDateFormat!,$shouldSkipContentStateLastUpdated:Boolean!,$shouldSkipAvailableContentStates:Boolean=false,$shouldSkipEditOnlyFields:Boolean=false){singleContent(id:$contentId){id,contentState(isDraft:$isDraft){id,name,color,restrictionLevel,isCallerPermitted@skip(if:$shouldSkipEditOnlyFields),lastModifierAaid@include(if:$isApprovalsFgOn)},contentStateLastUpdated(format:$format,isDraft:$isDraft)@skip(if:$shouldSkipContentStateLastUpdated){value}},availableContentStates(contentId:$contentId)@skip(if:$shouldSkipAvailableContentStates){customContentStates{name,color,id},spaceContentStates{name,color,id,restrictionLevel}}}"
  }
};
})();

(node as any).hash = "f76426744ff28f16601d3ae4d51a17fb";

export default node;
